import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LhWorkbenchModule } from '@ewafi/angular/panels/workbench';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    LhWorkbenchModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {}
